// These colors should exactly match those in the Zapier Design System.
//
// 000 is the lightest variant of a color.
// 500 is the "normal" variant of a color. When we say "blue", we mean "blue500".
// 900 is the darkest variant of a color.
const Colors = {
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent',
  inherit: 'inherit',
  currentColor: 'currentColor',
  // Greys
  grey000: '#FAFAFA',
  grey100: '#F2F2F2',
  grey200: '#E6E6E6',
  grey300: '#D9D9D9',
  grey400: '#CCCCCC',
  grey500: '#999999',
  grey700: '#666666',
  grey900: '#333333',
  // Reds
  red000: '#ffe1d5',
  red100: '#ffd2bf',
  red200: '#ffa38c',
  red500: '#ff4a00',
  red600: '#e52f00',
  red700: '#c63a00',
  // Blues
  blue100: '#f3f8ff',
  blue300: '#00bfff',
  blue500: '#136bf5',
  blue700: '#105bd0',
  // Oranges
  orange100: '#feddc8',
  orange200: '#fec19b',
  orange500: '#fd7622',
  orange600: '#e46a1f',
  // Yellows
  yellow100: '#fff0cf',
  yellow200: '#fff7e0',
  yellow400: '#ffcf61',
  yellow500: '#ffc43e',
  yellow600: '#e5b038',
  // Greens
  green000: '#daf5e6',
  green100: '#c4f3ea',
  green200: '#95ead9',
  green300: '#daf5e6',
  green400: '#62d493',
  green500: '#13d0ab',
  green600: '#11bb9a',
  // Aquamarines
  aquamarine100: '#d1f2fb',
  aquamarine200: '#ace7f8',
  aquamarine500: '#46caef',
  aquamarine600: '#3fb6d7',
  // Purples
  purple100: '#d7d7fa',
  purple200: '#b7b8f7',
  purple500: '#6061ed',
  purple600: '#5657d5',
  // Pinks
  pink100: '#fec6dc',
  pink200: '#fd99c0',
  pink500: '#fc1c74',
  pink600: '#e31968',
};
export type ColorName = keyof typeof Colors;
export type ColorValue = typeof Colors[keyof typeof Colors];
export default Colors;
